import {ImportModuleKulturnavRef} from '../../core/definitions/import-module';

/** How many of an objectid's characters its short form keeps. */
const SHORT_UUID_LENGTH = 8;

/** What stands for the KulturNav entity `ref` names: its name, else the
 * start of its objectid and «…». */
export function kulturnavRefText(ref: ImportModuleKulturnavRef): string {
  return ref.name || `${ref.uuid.slice(0, SHORT_UUID_LENGTH)}…`;
}
